import * as UnitDivide from "../unit-divide";
import { Watt, BtuPerHour } from "./power";
import { SquareMeter, SquareFeet } from "./area";
// Intensity
export var WattPerSquareMeter = UnitDivide.powerByArea("WattPerSquareMeter", Watt, SquareMeter);
export var BtuPerHourPerSquareFeet = UnitDivide.powerByArea("BtuPerHourPerSquareFeet", BtuPerHour, SquareFeet);
//# sourceMappingURL=intensity.js.map